<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Relatório Global de Marcações Internas</h2>
                    </div>
                </div>

                <div class="panel-body">

                    <form [formGroup]="formularioGlobalDeMarcacoesInternas" (ngSubmit)="onSubmit()">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                                <mat-label>Data Inicial e Final</mat-label>

                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate placeholder="Data Inicial" formControlName="dataInicial"
                                        required>
                                    <input matEndDate placeholder="Data Final" formControlName="dataFinal" required>
                                </mat-date-range-input>

                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>

                                <mat-error
                                    *ngIf="formularioGlobalDeMarcacoesInternas.controls.dataInicial.hasError('invalidDate') || formularioGlobalDeMarcacoesInternas.controls.dataFinal.hasError('invalidDate')">
                                    Datas inválidas ou com intervalos não permitidos.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-6 col-md-6 col-sm-6 col-12">
                                <mat-label>Agrupar por</mat-label>
                                <mat-select value="Agrupar por" formControlName="codTipoAgrupamento"
                                    name="codTipoAgrupamento" id="codTipoAgrupamento">
                                    <mat-option *ngFor="let tipoAgrupamento of listaTipoAgrupamentoParaMarcacaoInterna"
                                        [value]="tipoAgrupamento.codigo">
                                        {{tipoAgrupamento.descricao}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioGlobalDeMarcacoesInternas.controls.codTipoAgrupamento.hasError('required')">
                                    O campo Agrupar por é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-lg-12 col-md-12 col-sm-12 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioGlobalDeMarcacoesInternas.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>